import { BRAND } from './brand';

export const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'https://api.cloudunifi.com';
export const LOGIN_URL = BRAND.loginUrl;
export const JWT_STORAGE_KEY = 'hanko_jwt';
export const IMPERSONATION_STORAGE_KEY = 'impersonate_user';
